module.exports = __webpack_public_path__ + "static/wheel-of-purpose-c415a26f4b5d242ce7de9c9a5e090c9a.png";